import axios from 'axios'

import { ERROR_MESSAGE_SAVING } from '../constants'
import { handleRequestError } from './request'

export const REQUEST_PENSION_CONTRIBUTIONS_SUMMARY = 'REQUEST_PENSION_CONTRIBUTIONS_SUMMARY'
export const RECEIVE_PENSION_CONTRIBUTIONS_SUMMARY = 'RECEIVE_PENSION_CONTRIBUTIONS_SUMMARY'
const SAVE_PENSION_CONTRIBUTIONS_SUMMARY = 'SAVE_PENSION_CONTRIBUTIONS_SUMMARY'

export const requestPensionContributionsSummary = (taxReturnId) => (dispatch) => {
    dispatch({ type: REQUEST_PENSION_CONTRIBUTIONS_SUMMARY, data: { taxReturnId } })

    axios
        .get(`/pensioncontributionsummaries/${taxReturnId}`)
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(
                receivePensionContributionsSummary({
                    fetchSuccessful: true,
                    ...responseData,
                })
            )
        })
        .catch((error) => {
            if (error?.status === 404) {
                dispatch(receivePensionContributionsSummary({ fetchSuccessful: true }))
                return
            }

            dispatch(receivePensionContributionsSummary({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

const receivePensionContributionsSummary = (data) => ({ type: RECEIVE_PENSION_CONTRIBUTIONS_SUMMARY, data })

const savePensionContributionsSummary = (data) => (dispatch) => {
    dispatch({ type: SAVE_PENSION_CONTRIBUTIONS_SUMMARY, data })

    const { taxReturnId } = data

    return axios
        .put(`/pensioncontributionsummaries/${taxReturnId}`, data)
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(receivePensionContributionsSummary(responseData))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

export const updateAndSavePensionContributionsSummary = (data) => (dispatch) => {
    dispatch(receivePensionContributionsSummary(data))
    return dispatch(savePensionContributionsSummary(data)).catch(() => {})
}
